<template>
	<div class="form-elements">
		<div class="row">
			<div class="col-md-12">
				<vuestic-widget headerText="Relatório de Carga Horária de Aulas práticas por Aluno">
					<div class="row">
						<div class="col-md-8" @input="handleInputStudents">
							<model-select :options="nomesAlunos" v-model="getAluno" placeholder="Informe o aluno para pesquisa"></model-select>
						</div>
						<div class="col-md-4">
							<button @click="getCargaHoraria()" class="btn btn-block btn-lg btn-secondary">Gerar</button>
						</div>
					</div>
				</vuestic-widget>

				<a href="#" hidden id="downloadRelatorioCargaHorariaAulasPraticasPorAluno"></a>

				<div v-show="load">
					<div class="d-flex justify-content-center">
						<div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
							<component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SelectIconGroup from "@/vuestic-theme/vuestic-components/vuestic-input/SelectIconGroup"
	import { ModelSelect } from 'vue-search-select'
	import * as spinners from "epic-spinners"
	import urlApi from '../../router/urlApi'

	export default {
		name: "relatorioCargaHorariaAulasPraticasPorAluno",
		components: {
			...spinners,
			ModelSelect,
			SelectIconGroup
		},
		data() {
			return {
				load: false,
                alunos: [],
				nomesAlunos: [],
				item: {
					alunoId: '',
					alunoName: ''
				},
				getAluno: ''
			}
		},
		mounted() {
		},
		created: function() {
			const url = `${urlApi}/alunos/get-alunos-por-auto-escola`;
			this.$http.get(url).then((res) => {
				const dadosAlunos = res.data.dados.alunos;
				dadosAlunos.forEach((aluno) => {
					this.alunos.push({'value': aluno.id_aluno, 'text': aluno.nome});
				})
			});
		},
		methods: {
			getCargaHoraria() {
				this.load = true;
				const idAluno = this.getAluno;

				if (!idAluno) {
					this.$toasted.show("Selecione um aluno.", {
						position: "top-right",
					});

					return this.load = false;
				}

				const url = `${urlApi}/aulas/praticas/carga-horaria/${idAluno}`;
				this.$http.get(url).then((res) => {
					var pdf = "data:application/octet-stream;base64," + res.data.dataPDF;
					var downloadPDF = document.getElementById("downloadRelatorioCargaHorariaAulasPraticasPorAluno");
					downloadPDF.download = "relatorio-carga-horaria-aulas-praticas-por-aluno.pdf";
					downloadPDF.href = pdf;
					downloadPDF.click();
					this.load = false;
				});
			},
			reset () {
				this.item = {}
			},
			selectFromParentComponent1 () {
				this.item = this.options[0]
			},
			reset2 () {
				this.item2 = ''
			},
			selectFromParentComponent2 () {
				this.item2 = this.options2[0].value
			},
            async handleInputStudents(e) {
                const inputText = e.target.value.toLowerCase();

                this.nomesAlunos = this.alunos
                    .filter(aluno =>
                        aluno.text.toLowerCase().startsWith(inputText)
                    )
                    .slice(0, 50)
            }
		}
	};
</script>
